export var UiUserNotificationTypes;
(function (UiUserNotificationTypes) {
    UiUserNotificationTypes["WELCOME_MEDIATION"] = "welcome_mediation";
})(UiUserNotificationTypes || (UiUserNotificationTypes = {}));
//# sourceMappingURL=UiUserNotificationSettingSpec.js.map